export default __webpack_public_path__ + "static/media/icon5.ff090046.png";